import { render } from "./FriendsList.vue?vue&type=template&id=53703cc2&scoped=true"
import script from "./FriendsList.vue?vue&type=script&lang=js"
export * from "./FriendsList.vue?vue&type=script&lang=js"

import "./FriendsList.vue?vue&type=style&index=0&id=53703cc2&scoped=true&lang=css"
import "./FriendsList.vue?vue&type=style&index=1&id=53703cc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53703cc2"]])

export default __exports__